import { useCallback } from 'react';
import { maxZoom, minZoom } from 'flow-builder/constants';
export function useZoom({ state, view }) {
    const { setViewState } = state;
    const onZoom = useCallback((newScale) => {
        if (!view.isReady) {
            return;
        }
        const restrictedNewScale = Math.min(Math.max(newScale, minZoom), maxZoom);
        view.viewport.setZoom(restrictedNewScale, true);
        setViewState({ scale: restrictedNewScale });
    }, [view.isReady, view.viewport, setViewState]);
    return onZoom;
}
